import { render } from "./qrCode.vue?vue&type=template&id=9ffcdd70"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"

import "./qrCode.vue?vue&type=style&index=0&id=9ffcdd70&lang=css"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__